import type { ApiOrgId } from 'api/types/ApiTypedId';
import {
  orgDashboardCreateEventRoute,
  orgDashboardCreateInternshipRoute,
  orgDashboardCreateJobRoute,
  orgDashboardCreateVolopRoute,
  orgDashboardManageListingsRoute,
  orgDashboardPostAListingRoute,
} from 'modules/orgDashboard/routing/orgDashboard.routes';

type Args = {
  orgId: ApiOrgId;
  listingType?: 'JOB' | 'INTERNSHIP' | 'VOLOP' | 'EVENT';
  isAllowedToPost: boolean;
};

/**
 * Get link to redirect to after selecting an org
 */
export function getPostAListingPageCreateListingPath({
  orgId,
  listingType,
  isAllowedToPost,
}: Args) {
  if (!isAllowedToPost) orgDashboardManageListingsRoute.with({ orgId });

  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (listingType) {
    case 'JOB':
      return orgDashboardCreateJobRoute.with({ orgId });
    case 'INTERNSHIP':
      return orgDashboardCreateInternshipRoute.with({ orgId });
    case 'VOLOP':
      return orgDashboardCreateVolopRoute.with({ orgId });
    case 'EVENT':
      return orgDashboardCreateEventRoute.with({ orgId });
    default:
      return orgDashboardPostAListingRoute.with({ orgId });
  }
}
